<script lang="ts">
	//Helpers
	import { real_id, real_id_z } from '../../../../helpers/interface_helpers';
	import { getZWaveDeviceDisplayName } from 'src/helpers/z_wave_gateway_helpers';
	import { capFirstChar } from '../../../../helpers/utilities';

	//Services
	import { format } from '../../../../services/i18n';

	//Configs
	import { devices_config_wave } from 'src/devices_config_wave';

	//Stores
	import { devices_settings, devices_status } from 'src/stores';

	//Design system components
	import { Alert, Button, toast } from '@Shelly/shelly-design-system';

	//Components
	import FactoryResetModal from 'src/components/FactoryResetModal.svelte';
	import { deleteDevice } from 'src/helpers/add_delete_helpers';
	import { resetDrawerClose } from 'src/helpers/drawer_helpers';

	export let device;

	const id = real_id_z(device.id);

	let showModal = false;

	const type = devices_config_wave[device.type]?.friendly_name || device.type;

	let factoryLoading = false;

	$: status = $devices_status?.[real_id(device?.id)];
	$: settings = $devices_settings?.[real_id(device.id)];
	$: displayName = getZWaveDeviceDisplayName(device, status, settings);

	const factoryReset = async () => {
		factoryLoading = true;

		const res = await deleteDevice(id);
		if (res?.isok) {
			resetDrawerClose();
			toast.open({
				type: 'success',
				title: $format('factory_reset_scc_toast', {
					values: { device_name: displayName },
				}),
				duration: 10000,
			});
		}

		factoryLoading = false;
	};
	$: props = {
		title: `${$format('reset_device_to_factory_stngs', {
			default: 'Reset Device to Factory Settings',
		})}?`,
		name: displayName,
		text: $format('resetting_device_msg', {
			values: { device_name: displayName },
			default:
				'Resetting the device ‘{device_name}’ to its factory settings will erase all data and settings, including its network configuration. To reconnect, use its Access Point network.',
		}),
		alert: {
			heading: $format('resseting_device_alert_msg', {
				default:
					'Resetting the device to factory settings will also delete the device from the app.',
			}),
			type: 'danger',
		},
		button_1: $format('button_reset_device', {
			default: 'Reset device',
		}),
		button_1_variant: 'danger',
		button_2: $format('button_cancel'),
		callback: factoryReset,
	};
</script>

<Alert
	class="mb-s"
	type="warning"
	heading={$format('factory_reset_description', { values: { type } })}
/>

<Button loading={factoryLoading} size="m" width="full" on:click={() => (showModal = true)}
	>{capFirstChar($format('button_factory_reset'))}</Button
>
{#if showModal}
	<FactoryResetModal bind:showModal {props} />
{/if}
